import React, { Suspense, lazy } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Navigate, Route, Routes } from "react-router-dom";
import PartnerConsoleShell from "./PartnerConsoleShell";
import { PARTNER_CONSOLE_BASE, PARTNER_CONSOLE_SEGMENT } from "./partnerConsoleRoutes";

const PartnerOverviewPage = lazy(() => import("./PartnerOverviewPage"));
const PartnerDashboardPage = lazy(() => import("./PartnerDashboardPage"));
const PartnerWorkspacesPage = lazy(() => import("./PartnerWorkspacesPage"));
const PartnerPricingPage = lazy(() => import("./PartnerPricingPage"));
const PartnerWorkspaceDetailPage = lazy(() => import("./PartnerWorkspaceDetailPage"));
const PartnerWorkspaceCreatePage = lazy(() => import("./PartnerWorkspaceCreatePage"));
const PartnerWorkspacesOnlinePage = lazy(() => import("./PartnerWorkspacesOnlinePage"));
const PartnerPassengerSalesPage = lazy(() => import("./PartnerPassengerSalesPage"));
const PortalTeamPage = lazy(() => import("../../PortalTeam/PortalTeamPage"));

function PartnerSectionFallback() {
  return (
    <Box sx={{ py: 6, display: "flex", justifyContent: "center", alignItems: "center" }} role="status" aria-live="polite">
      <CircularProgress size={32} />
    </Box>
  );
}

const PartnerConsole = () => {
  return (
    <Routes>
      <Route element={<PartnerConsoleShell />}>
        <Route index element={<Navigate to={PARTNER_CONSOLE_SEGMENT.overview} replace />} />
        <Route
          path={PARTNER_CONSOLE_SEGMENT.overview}
          element={
            <Suspense fallback={<PartnerSectionFallback />}>
              <PartnerOverviewPage />
            </Suspense>
          }
        />
        <Route
          path={PARTNER_CONSOLE_SEGMENT.live}
          element={<Navigate to={`${PARTNER_CONSOLE_BASE}/dashboard/live`} replace />}
        />
        <Route
          path={`${PARTNER_CONSOLE_SEGMENT.dashboard}/:tab`}
          element={
            <Suspense fallback={<PartnerSectionFallback />}>
              <PartnerDashboardPage />
            </Suspense>
          }
        />
        <Route
          path={PARTNER_CONSOLE_SEGMENT.dashboard}
          element={<Navigate to={`${PARTNER_CONSOLE_BASE}/dashboard/live`} replace />}
        />
        <Route
          path={PARTNER_CONSOLE_SEGMENT.workspaces}
          element={
            <Suspense fallback={<PartnerSectionFallback />}>
              <PartnerWorkspacesPage />
            </Suspense>
          }
        />
        <Route
          path={PARTNER_CONSOLE_SEGMENT.presence}
          element={
            <Suspense fallback={<PartnerSectionFallback />}>
              <PartnerWorkspacesOnlinePage />
            </Suspense>
          }
        />
        <Route
          path={PARTNER_CONSOLE_SEGMENT.pricing}
          element={
            <Suspense fallback={<PartnerSectionFallback />}>
              <PartnerPricingPage />
            </Suspense>
          }
        />
        <Route
          path={PARTNER_CONSOLE_SEGMENT.workspaceCreate}
          element={
            <Suspense fallback={<PartnerSectionFallback />}>
              <PartnerWorkspaceCreatePage />
            </Suspense>
          }
        />
        <Route
          path={`${PARTNER_CONSOLE_SEGMENT.workspaces}/:dominioId`}
          element={
            <Suspense fallback={<PartnerSectionFallback />}>
              <PartnerWorkspaceDetailPage />
            </Suspense>
          }
        />
        <Route
          path={PARTNER_CONSOLE_SEGMENT.team}
          element={
            <Suspense fallback={<PartnerSectionFallback />}>
              <PortalTeamPage mode="partner" />
            </Suspense>
          }
        />
        <Route
          path={PARTNER_CONSOLE_SEGMENT.passagens}
          element={
            <Suspense fallback={<PartnerSectionFallback />}>
              <PartnerPassengerSalesPage />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
};

export default PartnerConsole;
